// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles-" + "4d9fd5d22c49a19f2b35" + ".css";
};